<template>
  <section class="reports section">
    <div class="container">
      <h1 class="title">Reported Users</h1>
      <div class="d-flex justify-content-end mb-4">
        <div class="d-flex align-items-center mr-auto text-dark">
          <span>
            <b v-if="!loading">
              <i class="fas fa-spin fa-circle-notch" v-if="busy"></i>
              {{ busy ? "" : reports.length }}/{{ total }}</b
            >
            <i class="fas fa-spin fa-circle-notch" v-if="loading"></i>
            Report{{ loading || total != 1 ? "s" : "" }}
          </span>
        </div>
        <select
          v-model="selectedStatus"
          :disabled="loading"
          @change="getFilteredReports()"
          class="form-control row m-0 w-auto"
        >
          <option
            v-for="status in statuses"
            :value="status.value"
            :key="status.value"
          >
            {{ status.label }}
          </option>
        </select>
      </div>
      <loading v-if="loading" class="white-bg shadow-card" />
      <error-alert v-if="error.active" />
      <alert v-if="!reports.length && !loading" class="white-bg shadow-card"
        >No reports to display</alert
      >
      <div v-if="!loading">
        <div
          class="col-12 card shadow-card p-3"
          v-for="userReport of reports"
          :key="userReport.id"
        >
          <h5
            class="text-center mb-3 mt-2 font-weight-normal"
            style="line-height: 1.5"
          >
            <span class="text-dark font-weight-bolder"
              >{{ userReport.vendor_last }}, {{ userReport.vendor_first }}</span
            >
            Reported
            <span class="text-dark font-weight-bolder"
              >{{ userReport.user_last }}, {{ userReport.user_first }}</span
            >
            on
            <small class="text-secondary">{{
              userReport.created_at | fullDate
            }}</small>
          </h5>
          <div class="border p-3 rounded">{{ userReport.reason }}</div>

          <div
            class="border-top mt-3 text-center pt-3 pb-2"
            v-if="!userReport.status && !userReport.handling"
          >
            <button
              @click="changeReportStatus(userReport, 1)"
              class="btn btn-success btn-sm"
            >
              Approve <i class="fas fa-thumbs-up"></i>
            </button>
            <button
              @click="changeReportStatus(userReport, 2)"
              class="btn btn-danger btn-sm ml-4"
            >
              Reject <i class="fas fa-thumbs-down"></i>
            </button>
          </div>
          <div
            class="border-top mt-3 text-center pt-3 pb-2"
            v-if="userReport.status || userReport.handling"
          >
            <h4
              v-if="!userReport.handling"
              :class="userReport.status == 1 ? 'text-primary' : 'text-danger'"
            >
              {{ userReport.status == 1 ? "Approved" : "Rejected" }}
            </h4>
            <span
              class="spinner-border spinner-border-sm"
              v-if="userReport.handling"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
        <mugen-scroll :handler="loadMore" :should-handle="!busy && !loading">
          <alert
            v-if="busy"
            class="text-center p-2 mb-0 rounded shadow-card white-bg"
            ><i class="fas fa-spin fa-circle-notch mr-2"></i>Loading more
            reports...</alert
          >
        </mugen-scroll>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import MugenScroll from "vue-mugen-scroll";

export default {
  name: "usersReports",
  components: {
    MugenScroll,
  },
  data() {
    return {
      statuses: [
        { value: -1, label: "Status" },
        { value: 0, label: "Pending" },
        { value: 1, label: "Approved" },
        { value: 2, label: "Rejected" },
      ],
      selectedStatus: -1,
      limit: 50,
      busy: false,
    };
  },
  computed: {
    ...mapState(["error"]),
    ...mapState({
      reports: (state) => state.users.paginatedReports.data,
      current: (state) => state.users.paginatedReports.current,
      total: (state) => state.users.paginatedReports.total || 0,
      loading: (state) => state.loading,
    }),
  },
  mounted() {
    this.getReports({ limit: this.limit });
  },
  methods: {
    ...mapActions({
      getReports: "users/getAllReports",
    }),
    changeReportStatus(report, status) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: `You are going to ${
            status == 1 ? "approve" : "reject"
          } this report`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, ${status == 1 ? "approve" : "reject"}`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            report.handling = true;
            this.$forceUpdate();
            this.$store
              .dispatch("users/changeReportStatus", { id: report.id, status })
              .then((success) => {
                report.handling = false;
                if (success) {
                  report.status = status;
                }
                this.$forceUpdate();
              });
          }
        });
    },
    getFilteredReports(page) {
      const payload = {
        limit: this.limit,
      };
      if (this.selectedStatus != -1) {
        payload.status = this.selectedStatus;
      }
      if (page) {
        payload.page = page;
      }
      this.getReports(payload).then(() => {
        this.busy = false;
      });
    },
    loadMore() {
      if (this.reports.length < this.total) {
        this.busy = true;
        this.getFilteredReports(this.current + 1);
      }
    },
  },
};
</script>
